import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { WifiSlash } from '@phosphor-icons/react';
import { WifiHigh as WifiLoadingAnim } from '../components/icons/wifiLoading.tsx';
import { useI18n } from '../context/I18nContext';
import { Button } from '../components/ui/Button';

export const NoInternetPage: React.FC = () => {
  const { t } = useI18n();
  const [isChecking, setIsChecking] = useState(false);

  useEffect(() => {
    const handleOnline = () => window.location.reload();
    window.addEventListener('online', handleOnline);
    return () => window.removeEventListener('online', handleOnline);
  }, []);

  const handleRecheck = async () => {
    setIsChecking(true);

    const checkInternet = async () => {
      try {
        const response = await fetch('/api/health', {
          method: 'HEAD',
          cache: 'no-cache',
          signal: AbortSignal.timeout(5000)
        });
        return response.ok;
      } catch {
        return false;
      }
    };

    const [isConnected] = await Promise.all([
      checkInternet(),
      new Promise(resolve => setTimeout(resolve, 1500))
    ]);

    if (isConnected) {
      window.location.reload();
    } else {
      setIsChecking(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      className="min-h-[100dvh] flex flex-col items-center justify-center text-center p-4 bg-base-50 dark:bg-base-950 text-base-900 dark:text-base-100"
    >
      {isChecking ? (
        <WifiLoadingAnim trigger='loop' weight='light' size={64} />
      ) : (
        <WifiSlash size={64} weight="duotone"  />
      )}
      
      <h1 className="text-display-md font-extrabold mb-3">
        {t('offline.title')}
      </h1>
      <p className="text-body-lg text-base-600 dark:text-base-400 max-w-md mb-8">
        {t('offline.message')}
      </p>
      
      <Button 
        variant="primary" 
        onClick={handleRecheck}
        disabled={isChecking}
      >
        {isChecking ? t('offline.checking') : t('offline.recheck')}
      </Button>
    </motion.div>
  );
};









